import React from 'react';
import LinkButton from '../../components/common/LinkButton';
import ClosableWarning from '../../components/common/ClosableWarning';
import { AWS_EU_LINK, CODE_DE_LINK, CREODIAS_LINK, US_WEST_LINK } from '../../constants/links';

export const CreoEUCentralWarning = () => {
  return (
    <ClosableWarning>
      <div style={{ fontSize: '0.85rem' }}>
        <b>WARNING: S1/S2/EU Central BYOC layers</b>
        <p>
          Layers that use S1 or S2 with S3 bucket in AWS EU Central are processed on different
          infrastructure, which require:
          <br />
          -The use of <LinkButton>{AWS_EU_LINK}</LinkButton> end-point instead of{' '}
          <LinkButton>{CREODIAS_LINK}</LinkButton> for these layers.
          <br />
          -Creodias layers should not be mixed with S1/S2/EU Central BYOC layers in the same
          configuration instance.
        </p>
      </div>
    </ClosableWarning>
  );
};

export const CreoUSWestWarning = () => {
  return (
    <ClosableWarning>
      <div style={{ fontSize: '0.85rem' }}>
        <b>WARNING: Landsat/MODIS/DEM/US West BYOC layers</b>
        <p>
          Layers that use Landsat/MODIS/DEM with S3 bucket in AWS US West are processed on different
          infrastructure, which require:
          <br />
          -The use of <LinkButton>{US_WEST_LINK}</LinkButton> end-point instead of{' '}
          <LinkButton>{CREODIAS_LINK}</LinkButton> for these layers.
          <br />
          -Creodias layers should not be mixed with Landsat/MODIS/DEM/US West BYOC layers in the
          same configuration instance.
        </p>
      </div>
    </ClosableWarning>
  );
};

export const CodeDeCreoByocWarning = () => {
  return (
    <ClosableWarning>
      <div style={{ fontSize: '0.85rem' }}>
        <b>WARNING: CREODIAS BYOC layers</b>
        <p>
          Layers that use BYOC with S3 bucket in CREODIAS are processed on different infrastructure,
          which require:
          <br />
          -The use of <LinkButton>{CREODIAS_LINK}</LinkButton> end-point instead of{' '}
          <LinkButton>{CODE_DE_LINK}</LinkButton> for these layers.
          <br />
          -Layers from different sources should not be mixed within the same configuration instance.
        </p>
        <p>
          In the next few weeks we will migrate these two end-points, but until then please take the
          above into consideration.
        </p>
      </div>
    </ClosableWarning>
  );
};
